<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeLogin"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeLogin" :campaign="campaign" />
    <!-- <PhoneInput /> -->

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>

    <v-footer padless v-if="campaign.is_show_footer">
      <v-col class="text-center footer" cols="12">
        <p class="ql-editor" v-html="campaign.footer_text"></p>
      </v-col>
    </v-footer>

    <DialogVerifyOtp
      ref="refVerifyOTP"
      v-model="dialogOtp"
      :dialogOtp="dialogOtp"
      :ref_code="ref_code"
      :site="site"
      @close="dialogOtp = false"
      @verifyOtp="verifyOtp"
      @sendOtp="sendOtp"
    ></DialogVerifyOtp>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Model } from "survey-core";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import MicrositeAxios from "@/config/microsite-service";
import DialogVerifyOtp from "@/components/dialogVerifyOtp-microsite.vue";
import {
  addClassQlEditorToSDDisplay,
  addDropdownPhoneCountry,
  customThemeSurveyJS,
} from "../../../config/general-function";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";
import {
  getCountries,
  getCountryCallingCode,
  parsePhoneNumberFromString,
} from "libphonenumber-js";

export default {
  name: "MicrositeLogin",
  inject: ["isAppLoading"],
  components: {
    Survey,
    DialogVerifyOtp,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    survey: null,
    surveyJson: null,
    themeJson: null,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },
    dialogOtp: false,
    ref_code: "",
    request_id: "",
    phone: "",
    phoneSendOTP: "",

    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  async created() {
    this.getSurveyAndTheme();
    if (this.campaign.is_use_phone_country) {
      const indexPhone = this.surveyJson.elements.findIndex(
        (x) => x.name == "phone"
      );
      if (indexPhone >= 0) {
        const model = this.surveyJson.elements[indexPhone];
        delete model["validators"];
        this.surveyJson.elements[indexPhone] = model;
      }
    }
    this.survey = new Model(this.surveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;
    this.handleSubmit();
    // ========== ========== ========== ==========
    addClassQlEditorToSDDisplay();
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    ...mapState("microsite", ["campaign"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
    countryList() {
      const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

      const getFlagEmoji = (countryCode) => {
        const codePoints = countryCode
          .toUpperCase()
          .split("")
          .map((char) => 127397 + char.charCodeAt(0));
        return String.fromCodePoint(...codePoints);
      };
      const _countryList = getCountries().map((countryCode) => {
        const dialCode = `+${getCountryCallingCode(countryCode)}`;

        // ดึงชื่อประเทศเต็ม เช่น 'Thailand', 'Japan', 'United States'
        const countryName = regionNames.of(countryCode) || countryCode;
        const flag = getFlagEmoji(countryCode);

        return {
          code: countryCode, // 'TH'
          dialCode: dialCode, // '+66'
          name: countryName, // 'Thailand'
          flag: flag, // '🇹🇭'
          label: `${flag} ${countryName} (${dialCode})`,
        };
      });

      return _countryList.sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  methods: {
    getSurveyAndTheme() {
      if (this.campaign.template_id == 3) {
        this.$router.push({ name: "microsite-register" });
        return;
      }
      const surveyJson = JSON.parse(this.campaign.survey_json);
      if (surveyJson && surveyJson.login && this.campaign.template_id != 3) {
        this.surveyJson = surveyJson.login;
      } else {
        this.surveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).login;
      }

      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
    handleSubmit() {
      this.survey.onComplete.add((sender) => {
        this.onSubmit(sender);
      });
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        const questionEl = options.htmlElement;
        if (["image_confirm"].includes(options.question.name)) {
          questionEl.style.cursor = "pointer"; // Optional: Change cursor to indicate clickable
          questionEl.onclick = () => {
            if (options.question.name == "image_confirm") {
              const isSurveyHasErrors = this.survey.hasErrors();
              if (isSurveyHasErrors) return;
              this.onSubmit(sender);
            }
          };
        } else if (["phone"].includes(options.question.name)) {
          const inputEl = questionEl.querySelector("input");
          if (inputEl) {
            inputEl.onkeydown = (event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                inputEl.blur();
                setTimeout(() => {
                  options.question.value = inputEl.value;
                  const isSurveyHasErrors = this.survey.hasErrors();
                  if (isSurveyHasErrors) return;
                  this.onSubmit(sender);
                }, 50);
              }
            };
          }
          // ========== ========== ========== ==========
          if (this.campaign.is_use_phone_country) {
            const countries = this.countryList;
            addDropdownPhoneCountry(questionEl, countries, "TH");
          }
        }
      });
    },
    validatePhoneCountry(sender, phone) {
      const questionEl = sender.getQuestionByName("phone")?.getWrapperElement();
      const selectedCountry = questionEl?.dataset.selectedCountry || "TH";
      // ========== ========== ========== ==========
      const isCleanInput = /^[0-9\s\-+]+$/.test(phone);
      const phoneNumber = parsePhoneNumberFromString(
        phone || "",
        selectedCountry
      );
      const isStrictMatch =
        isCleanInput && phoneNumber && phoneNumber.isValid();
      if (!isStrictMatch) {
        return null;
      }
      const formattedE164Phone = phoneNumber.number;
      phone = formattedE164Phone;
      return phone;
    },
    async onSubmit(sender) {
      this.isAppLoading(true);
      let phone = (sender?.data?.phone || "").trim();
      if (this.campaign.is_use_phone_country) {
        const _validatePhoneCountry = this.validatePhoneCountry(sender, phone);
        if (!_validatePhoneCountry) {
          sender.clear(false);
          const targetQuestion = sender.getQuestionByName("phone");
          if (targetQuestion) {
            targetQuestion.addError(this.$t("microsite.invalidPhoneNumber"));
            targetQuestion.focus();
          }
          this.isAppLoading(false);
          return;
        } else {
          phone = _validatePhoneCountry;
        }
      }
      this.phone = phone;
      this.phoneSendOTP = (sender?.data?.phone || "").trim();
      // ========== ========== ========== ==========
      try {
        const response = await MicrositeAxios.get(
          `checkPhoneNumber/${this.campaign.id}?phone=${encodeURIComponent(
            this.phone
          )}`
        );
        const userExists = response.data.data.users;
        this.$store.commit("microsite/SET_USER", {
          user: {
            phone: userExists ? userExists.phone : this.phone,
            fullname: userExists ? userExists.fullname : null,
            line_id: userExists ? userExists.line_id : null,
            detail: userExists ? userExists.detail : null,
            history: userExists ? userExists.CampaignTransaction : null,
            status_consent: userExists ? userExists.status_consent : null,
          },
        });

        if (userExists) {
          const validatePhone =
            this.phoneSendOTP && /^0[689]\d{8}$/.test(this.phoneSendOTP);
          if (this.campaign.is_use_otp && validatePhone) {
            this.sendOtp();
          } else {
            this.$router.push({ name: "microsite-menu" });
          }
        } else {
          if (this.campaign.is_show_register == false) {
            this.$swal
              .fire({
                icon: "error",
                text: this.$t("microsite.errUserNotFound"),
                showConfirmButton: true,
              })
              .then(() => {
                this.$router.go(0);
              });
          } else {
            this.$router.push({ name: "microsite-register" });
          }
        }
      } catch (error) {
        this.$swal
          .fire({
            icon: "error",
            title: this.$t("microsite.errGeneral"),
            showConfirmButton: true,
          })
          .then(() => {
            this.$router.go(0);
          });
        console.log(error);
      }
      this.isAppLoading(false);
    },
    registerForm() {
      this.$router.push({ name: "microsite-register" });
    },

    sendOtp() {
      this.dialogOtp = true;
      MicrositeAxios.post("sendOtpMicrosite", {
        mobile: `${this.phoneSendOTP}`,
        site_id: this.campaign.site_id,
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.dialogOtp = true;
            this.ref_code = res.data.data.ref_code;
            this.request_id = res.data.data.request_id;
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.go(0);
          }
        });
    },
    verifyOtp(code) {
      this.isAppLoading(true);
      MicrositeAxios.post("verifyOtpMicrosite", {
        request_id: this.request_id,
        code: code,
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.$swal
              .fire({
                icon: "success",
                title: this.$t("microsite.loginSuccess"),
                showConfirmButton: false,
                timer: 1500,
              })
              .then(() => {
                this.$router.push({ name: "microsite-menu" });
              });
          }
        })
        .catch((err) => {
          if (this.$refs.refVerifyOTP) {
            this.$refs.refVerifyOTP.clearOTP();
          }
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
  },
};
</script>

<style scoped>
::v-deep .footer p {
  word-break: break-all;
  margin-bottom: 0 !important;
}
::v-deep .v-footer {
  margin-top: auto !important;
  margin-bottom: 0px !important;
}

/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
